import * as Storage from './storage';
import { post, get } from './request';
import { UserState } from '../types/UserState';
import { getPersistor } from '@rematch/persist';
import { ResponsibleCompanyEnum } from '../enums/responsible-company.enum';
export const isAuthenticated = () => null !== Storage.get('uid');

export const cleanUserSession = () => {
  const keys = Object.keys(Storage.getAll());
  keys.forEach(key => {
    if (key !== 'hasUpdatedEmails') {
      Storage.remove(key);
    }
  });
  getPersistor().purge();
  window.location.reload();
};

export async function oAuthSignIn(email: string, password?: string): Promise<UserState> {
  const isRV = process.env.REACT_APP_IS_RV === 'true';
  const payload = {
    email: email,
    password: password,
    company: isRV ? ResponsibleCompanyEnum.vistorias : ResponsibleCompanyEnum.confiax
  };

  const response = await post(`/oauth/verify-user`, payload);
  return response;
}

export async function confiaxSignIn(email: string, password: string): Promise<string> {
  const payload: any = {
    email: email,
    password: password
  };

  const response = await post(`/oauth/login`, payload);
  return response;
}
export interface CheckIsExternalResponseInterface {
  isExternal: boolean;
  hasPassword: boolean;
  company?: string;
}

export async function verifyExternalLogin(
  email: string
): Promise<CheckIsExternalResponseInterface> {
  const response = await get(`/oauth/external-login/?email=${email}`);
  return response;
}

export function redirectToOAuthLogin(email: string): void {
  const isDevelop =
    process.env.REACT_APP_IS_DEVELOP === 'true' ||
    window.location.hostname === 'app.develop.seguros.redevistorias.com.br' ||
    window.location.hostname === 'localhost';

  const redirectAddress =
    window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '');

  const url = !isDevelop
    ? `${process.env.REACT_APP_AUTH_RV_URL}/login?response_type=token&username=${email}&email=${email}&redirect_uri=${process.env.REACT_APP_4SEG_URL}/auth-validate&scope=users%20order:*%20client:*%20device:*%20financial:*%20package:*%20entity:*%20integration:*&client_id=4seg`
    : `${process.env.REACT_APP_AUTH_RV_DEV_URL}/login?response_type=token&username=${email}&email=${email}&redirect_uri=${redirectAddress}/auth-validate&scope=users%20order:*%20client:*%20device:*%20financial:*%20package:*%20entity:*%20integration:*&client_id=4seg`;
  window.location.replace(url);
  window.location.assign(url);
}

export function redirectToOAuthCreate(email: string): void {
  const isDevelop =
    process.env.REACT_APP_IS_DEVELOP === 'true' ||
    window.location.hostname === 'app.develop.seguros.redevistorias.com.br' ||
    window.location.hostname === 'localhost';
  const redirectAddress =
    window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '');
  const url = !isDevelop
    ? `${process.env.REACT_APP_AUTH_RV_URL}/account-manager/create-account?client_id=4seg&redirect_uri=${process.env.REACT_APP_4SEG_URL}/auth-validate&response_type=token&username=${email}&email=${email}&origin=4SEG&scope=users%20inspections%20devices`
    : `${process.env.REACT_APP_AUTH_RV_DEV_URL}/account-manager/create-account?client_id=4seg&redirect_uri=${redirectAddress}/auth-validate&response_type=token&username=${email}&email=${email}&origin=4SEG&scope=users%20inspections%20devices`;
  window.location.assign(url);
}

export interface VerifyOnOAuthInterface {
  isValid: boolean;
  responsibleCompany?: string;
  message?: string;
}

export async function checkUserExists(email: string): Promise<VerifyOnOAuthInterface> {
  const payload = {
    email: email
  };

  const response = await post(`/oauth/verify`, payload);
  return response;
}

export async function authenticateUser(
  email: string,
  password: string
): Promise<boolean> {
  const payload = {
    email: email,
    password: password
  };

  const response = await post(`/oauth/authenticate`, payload);
  return response;
}

export function redirectToCapturePage(): void {
  window.location.href =
    'https://conteudo.somosgruporv.com.br/solucoes-gruporv?redirectApp=redeConfiax';
}

export function redirectToConfiax(token: string): void {
  const isDevelop =
    process.env.REACT_APP_IS_DEVELOP === 'true' ||
    window.location.hostname === 'app.develop.seguros.redevistorias.com.br' ||
    window.location.hostname === 'localhost';
  const redirectAddress =
    window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '');
  const url = !isDevelop
    ? `${process.env.REACT_APP_4SEG_URL}/auth-validate#access_token=${token}&token_type=Bearer&expires_in=86400`
    : `${redirectAddress}/auth-validate#access_token=${token}&token_type=Bearer&expires_in=86400`;

  window.location.replace(url);
}

export async function validateUser(accessToken: string): Promise<any> {
  const payload = {
    accessToken: accessToken
  };

  const response = await post(`/oauth/validate`, payload);
  return response;
}

export async function forgotPassword(email: string): Promise<void> {
  const payload = {
    email: email
  };
  const response = await post('/oauth/forgot-password', payload);
  return response;
}

export async function createPassword(password: string, userId: string): Promise<void> {
  const payload = {
    userId,
    password
  };
  const response = await post('/oauth/create-password', payload);
  return response;
}
